/**
 * Password rules aligned with backend `passwordMeetsPolicy` (validators/auth.validators.js).
 */
export function getPasswordChecks(password) {
  const p = String(password || '');
  return {
    len10: p.length >= 10,
    lower: /[a-z]/.test(p),
    upper: /[A-Z]/.test(p),
    digit: /[0-9]/.test(p),
    special: /[^A-Za-z0-9]/.test(p),
  };
}

export function passwordIsStrong(password) {
  const c = getPasswordChecks(password);
  return c.len10 && c.lower && c.upper && c.digit && c.special;
}

const RULES = [
  { key: 'len10', label: 'At least 10 characters' },
  { key: 'lower', label: 'One lowercase letter (a–z)' },
  { key: 'upper', label: 'One uppercase letter (A–Z)' },
  { key: 'digit', label: 'One number (0–9)' },
  { key: 'special', label: 'One special character (!@#$…)' },
];

export function PasswordRequirements({ password, confirmPassword }) {
  const checks = getPasswordChecks(password);
  const metCount = Object.values(checks).filter(Boolean).length;
  const confirmOk =
    confirmPassword.length > 0 && password === confirmPassword && passwordIsStrong(password);

  return (
    <div className="ace-password-panel">
      <div className="ace-password-meter" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => (
          <span
            key={i}
            className={`ace-password-meter__seg ${i < metCount ? 'ace-password-meter__seg--on' : ''}`}
          />
        ))}
      </div>
      <p className="ace-password-panel__title">Password requirements</p>
      <ul className="ace-password-rules">
        {RULES.map(({ key, label }) => (
          <li
            key={key}
            className={`ace-password-rules__item ${checks[key] ? 'ace-password-rules__item--ok' : ''}`}
          >
            <span className="ace-password-rules__icon" aria-hidden="true">
              {checks[key] ? '✓' : '○'}
            </span>
            {label}
          </li>
        ))}
      </ul>
      {confirmPassword.length > 0 ? (
        <p
          className={`ace-password-confirm ${confirmOk ? 'ace-password-confirm--ok' : 'ace-password-confirm--bad'}`}
        >
          <span className="ace-password-rules__icon" aria-hidden="true">
            {confirmOk ? '✓' : '○'}
          </span>
          Passwords match
        </p>
      ) : null}
    </div>
  );
}
